const ProgressBar = require('progressbar.js')

module.exports = function(project, options, type){
	var defaults = {
		strokeWidth: 2,
		easing: 'easeInOut',
		duration: 2400,
		color: '#6dc82c',
		trailColor: 'transparent',
		trailWidth: 0,
		svgStyle: null
	}

	if(typeof options == "object") defaults = options;

	if(type == "line") {
		return new ProgressBar.Line(project, defaults)
	} else {
		return new ProgressBar.Circle(project, defaults)
	}
}
